import axios from "axios";
import { getRestApiUrl } from "./utils/backendOverride";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API}`,
});

API.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${process.env.REACT_APP_TOKEN_PAYMENTS}`;
  // Resolved per request: the A/B company is routed to the sin-Prisma backend.
  config.baseURL = `${getRestApiUrl()}/v2`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const jcnError = {
      message: error.response?.data?.userMessage || error.response?.data,
    };
    if (jcnError.message === "UNAUTHORIZED") {
      localStorage.clear();
      window.location.replace("/");
    }
    return Promise.reject(jcnError);
  }
);

export default API;
